import type { ReflectionFontSchemaType, ReflectionSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'
import { font } from 'services/Branding/common.styled'
import type { ElementFontCss, ElementStyleCss } from 'services/Branding/types'

const TextareaStyled = styled.textarea<{
  $styles: ElementStyleCss<ReflectionSchemaType>
  $fonts: ElementFontCss<ReflectionFontSchemaType>
}>`
  width: 100%;
  padding: 20px 24px;
  height: 100%;
  resize: none;
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: var(--color-delimiter-secondary) transparent;
  &::-webkit-scrollbar {
    width: 8px;
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--color-delimiter-secondary);
    border-radius: 4px;
  }
  border-radius: ${({ $styles }) => $styles.common.borderRadius};
  border-width: ${({ $styles }) => $styles.common.borderWidth};
  border-color: ${({ $styles }) => $styles.common.borderColor};
  border-style: ${({ $styles }) => $styles.common.borderStyle};
  background-color: ${({ $styles }) => $styles.common.backgroundColor};
  box-shadow: ${({ $styles }) => $styles?.effects?.boxShadow};
  outline: none;
  ${({ $fonts }) => font($fonts.base)}

  &:hover {
    background-color: ${({ $styles }) => $styles.input_hover.backgroundColor};
  }
  &:focus {
    background-color: ${({ $styles }) => $styles.input_focus.backgroundColor};
  }
  &::placeholder {
    ${({ $fonts }) => font($fonts.placeholder)}
  }

  ${outline}
`

export default TextareaStyled
